import type { Strings } from '../index.ts';

/**
 * Die Links in einer Videobeschreibung oder einem Kommentar. Zwei Sätze, die beide dieselbe Frage
 * beantworten: wohin führt dieser Link? Ein Link auf eine Seite dieser App trägt das Zeichen von
 * Visious, einer, der die App verlässt, das Zeichen der Seite, zu der er führt, und diese Sätze sind
 * das, was eine Vorlesehilfe anstelle des Bildes hört.
 */
export const richText: Strings['richText'] = {
  opensHere: 'Wird in Visious geöffnet.',
  opensOn: (site) => `Wird auf ${site} geöffnet.`,
};
